import axios from 'axios'

const url = 'http://canales2.servientrega.com:8086/Services/Locations';

export default class ApiService {

    getPointsAttention(lat, lon, radio){
      return axios({
          method: 'get',
          url: `${url}/api/PuntosServiInformacion/${lat}/${lon}/${radio}`,
          validateStatus: () => true
      })
      .then(response => response)
      .catch(error => error);
    }
}
